import React from 'react';
import { Check, X } from 'lucide-react';

const LEVELS = [
  { label: 'Too short', bar: 'bg-red-500', text: 'text-red-600' },
  { label: 'Weak', bar: 'bg-red-500', text: 'text-red-600' },
  { label: 'Fair', bar: 'bg-amber-500', text: 'text-amber-600' },
  { label: 'Good', bar: 'bg-blue-600', text: 'text-blue-600' },
  { label: 'Strong', bar: 'bg-brand-navy-deep', text: 'text-brand-navy-deep' },
];

export default function PasswordStrength({ password }) {
  if (!password) return null;
  const rules = [
    { ok: password.length >= 8, text: 'At least 8 characters' },
    { ok: /[a-z]/.test(password) && /[A-Z]/.test(password), text: 'Upper and lower case letters' },
    { ok: /\d/.test(password), text: 'A number' },
    { ok: /[^A-Za-z0-9]/.test(password), text: 'A symbol' },
  ];
  const score = password.length < 6 ? 0 : Math.max(1, rules.filter((r) => r.ok).length);
  const level = LEVELS[score];

  return (
    <div className="mt-2 animate-fade-up">
      <div className="flex gap-1.5">
        {[1, 2, 3, 4].map((n) => (
          <div key={n} className="h-1.5 flex-1 rounded-full bg-gray-200 overflow-hidden">
            <div className={`h-full rounded-full transition-all duration-500 ${level.bar}`} style={{ width: score >= n ? '100%' : '0%' }} />
          </div>
        ))}
      </div>
      <p className={`text-xs font-semibold mt-1.5 ${level.text}`}>{level.label}</p>
      <ul className="grid grid-cols-2 gap-x-3 gap-y-1 mt-1.5">
        {rules.map((r) => (
          <li key={r.text} className={`flex items-center gap-1 text-xs transition-colors ${r.ok ? 'text-brand-navy-deep font-bold' : 'text-gray-400'}`}>
            {r.ok ? <Check key="ok" strokeWidth={3} className="w-3.5 h-3.5 animate-pop" /> : <X className="w-3.5 h-3.5" />}{r.text}
          </li>
        ))}
      </ul>
    </div>
  );
}